export const actions = {
  CREATE: 'create',
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete'
};

export const resources = {
  CUSTOMER: "customer",
  ACCOUNT: 'account',
  REALM: 'realm',
  ORGANIZATION: "organization",
  APPLICATION: "application",
  MODULE: 'module',
};
